// console.log(`Env variable: ${process.env.NODE_ENV}`);


const HPConfig = {
    environment: '#{Environment.AbstractName}',
    renovateLink: '#{Urls.Web.FOAHI}',
    heroProApi: '#{Urls.API.HEROPro}/',
    authApi: '#{Urls.API.Auth}',
    heroProLoginLink: '#{Urls.Web.Contractor}/login',
    heroProLink: '#{Urls.HEROPro}',
    applyLink: '#{Urls.HEROApplication}',
    idVerifyLink: '#{Urls.idVerify}',
    proPitchLink: '#{Urls.Propitch}',
    benjiFinancingLink: '#{Urls.Web.Contractor}',
    heroCalcLink: '#{Urls.RAFinancingCalculator}',
    rackspaceCdn: '#{herobl.ContractorCDNPath}',
    mapBoxAuthKey: '#{MapBox.HEROProAuthKey}',
    qualityRatingEnabled: '#{HEROPro.QualityRatingEnabled}',
    tokenExpirationInSeconds: '#{HEROPro.TokenExpirationInSeconds}',
    docGenWaitTimeInSeconds: '#{HEROPro.DocGenWaitTimeInSeconds}',
    showMFACalc: 'true',
    addProductsPartialSearchEnabled: '#{HEROPro.AddProductsPartialSearchEnabled}',
    splashMtnEnabled: '#{HEROPro.splashMtnEnabled}',
    splashMtnUrl: '#{HEROPro.splashMtnUrl}',
    splashMtnApiKey: '#{HEROPro.splashMtnApiKey}',
    addProductsWebLink: '#{Urls.Web.AddProducts}',
    apiVersion: 'unknown',
    applicationSource: '35',
    screenSizes: {
        screen_sm: 768,
        screen_md: 992,
        screen_lg: 1200,
    },
    plaid: {
        url: '#{Plaid.APIUrl}',
        clientId: '#{Plaid.ClientId}',
        publicKey: '#{Plaid.PublicKey}',
    },
};

if (process.env.NODE_ENV === 'development') {
    HPConfig.environment = 'DEV';
    HPConfig.renovateLink = 'http://www.dev-foahomeimprovement.com/';
    HPConfig.heroProApi = 'https://proapi.dev-foahomeimprovement.com/';
    HPConfig.authApi = 'https://authapi.dev-foahomeimprovement.com/';
    HPConfig.heroProLoginLink = 'https://contractor.dev-foahomeimprovement.com/login'; // New HERO Pro login link
    HPConfig.heroProLink = 'https://pro.dev-foahomeimprovement.com';
    HPConfig.applyLink = 'https://apply.dev-foahomeimprovement.com/';
    HPConfig.idVerifyLink = 'https://verifydev.renovateamerica.com/';
    HPConfig.proPitchLink = 'https://proposaldev.heroprogram.com/';
    HPConfig.benjiFinancingLink = 'https://contractordev.benjifinancing.com/';
    HPConfig.heroCalcLink = 'https://calc.devrafinancing.com/';
    HPConfig.rackspaceCdn = 'https://19f39596af1cdc4c037d-9b07ea34782da317d49e180c0a5bc867.ssl.cf2.rackcdn.com/';
    HPConfig.mapBoxAuthKey = 'pk.eyJ1IjoianJpY2htb25kIiwiYSI6ImNpbTQyczFoYzAwNW50em02YjB0c2l3cDEifQ.VXU8NHSLe3s5MLjhk0e5DA';
    HPConfig.qualityRatingEnabled = 'true';
    HPConfig.tokenExpirationInSeconds = 600000;
    HPConfig.docGenWaitTimeInSeconds = 45;
    HPConfig.showMFACalc = 'false';
    HPConfig.addProductsPartialSearchEnabled = 'true';
    HPConfig.splashMtnEnabled = 'both';
    HPConfig.splashMtnUrl = 'https://ut6rx1f93l.execute-api.us-west-2.amazonaws.com/0_0';
    HPConfig.splashMtnApiKey = 'H1I6f2HYJHmok3PnVGDq7nLDXeOOAZUalqQC574a';
    HPConfig.addProductsWebLink = 'https://addproducts.devrenovateamerica.com';

    HPConfig.plaid.url = 'https://sandbox.plaid.com/';
    HPConfig.plaid.publicKey = 'd6eb2ea28494fdaef199c57961a4e1';
    HPConfig.plaid.clientId = '5dcc524ec0e3b800125554ba';


    // HPConfig.addProductsWebLink = 'http://localhost:4200';
    // heroProApi: "https://localhost:44307/",
    // heroProLoginLink: "http://localhost:3000/",
}

export default HPConfig;



// WEBPACK FOOTER //
// ./src/app/config/app.config.js